import Vue from 'vue'
import VueAMap from 'vue-amap'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
// import i18n from './i18n/i18n'
import './plugins/element.js'
import './plugins/moment.js'
import './plugins/axios.js'
import './plugins/common.js'
import './utils/rem'
import 'normalize.css'// A modern alternative to CSS resets
// import '../public/static/css/light/index.css'
import './styles/c.less'
import './components'
import './filter'
import echarts from 'echarts'
Vue.use(ElementUI)
Vue.use(VueAMap)
Vue.prototype.$echarts = echarts
Vue.prototype.$eventBus = new Vue()
VueAMap.initAMapApiLoader({
  key: 'bff22e3ec79d523c9ac949adb80847f7',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.Geolocation'],
  v: '1.4.5'
})

Vue.config.productionTip = false

new Vue({
	router,
  store,
  // i18n,
  render: h => h(App),
}).$mount('#app')
